import(/* webpackMode: "eager" */ "/app/src/app/forgot/page.tsx");
